// test2543
(2543 && 0);
